import React, { type ReactNode } from 'react';

interface SeatsPopoverInput {
	usedSeats: number;
	maxSeats: number;
	includedSeats: number;
	purchasedSeats: number;
	seatPrice?: number;
	isTrialBeforePlanSelected?: boolean;
}

export interface SeatsPopoverContent {
	title: string;
	message: ReactNode;
	hideUpdateSeats?: boolean;
}

const getSeatsPopoverContent = ({
	usedSeats,
	maxSeats,
	includedSeats,
	purchasedSeats,
	seatPrice,
	isTrialBeforePlanSelected = false,
}: SeatsPopoverInput): SeatsPopoverContent => {
	if (isTrialBeforePlanSelected) {
		return {
			title: `Your plan has access to ${maxSeats} user ${maxSeats === 1 ? 'seat' : 'seats'}`,
			message: (
				<>
					<p>
						All user seats are currently being used. Upgrade your plan for more
						user seats.
					</p>
					<ul className="seats-popover-list">
						<li>{includedSeats} included</li>
					</ul>
				</>
			),
			hideUpdateSeats: true,
		};
	}

	const isFilled = usedSeats >= maxSeats;

	const title = `Your plan has access to ${maxSeats} user ${maxSeats === 1 ? 'seat' : 'seats'}`;

	const messageText = `${isFilled ? 'All user seats are currently being used. ' : ''}Add additional seats for a monthly fee, upgrade your plan, or delete existing users for access to more seats.`;

	const message = (
		<>
			<p>{messageText}</p>
			<ul className="seats-popover-list">
				<li>{includedSeats} included</li>
				{purchasedSeats > 0 && (
					<li>
						{purchasedSeats} additional
						{seatPrice !== undefined && (
							<div className="seat-price">${seatPrice.toFixed(2)}/user/mo</div>
						)}
					</li>
				)}
			</ul>
		</>
	);

	return { title, message };
};

export default getSeatsPopoverContent;
